import LoadContentBase from './load-content-base';
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-load-content', observe: true })
export class LoadContentComponent extends LoadContentBase {
	constructor(element: HTMLElement) {
		super(element);
		this.handleLoadContent();
	}
}
